<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

            <h2>Grupos</h2>
            <p>Esta tela é destinada a criação e gerenciamento dos grupos de trabalho para este simulador.</p>

            <div class="form-group mt-4">
                <label for="label" class="input-label">Pesquisar por:</label>
                <div class="form-group">
                    <select placeholder="Selecione" v-model="pesquisar_por" class="form-control">
                        <option value="descricao" selected>Nome do grupo</option>
                        <option value="usuario">Nome de membro</option>
                    </select>
                </div>
            </div>

            <div class="form-group mt-1">
                <label for="label" class="input-label">Nome a pesquisar:</label>
                <input type="text" id="campo_pesquisar" class="form-control" v-model="campo_pesquisar" required placeholder="Nome a pesquisar">
            </div>
            <div style="text-align: right; width: 100%;" class="mb-1 mt-1">
                <button @click="CarregarGrupos(campo_pesquisar, pesquisar_por)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">search</span> 
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Pesquisar</label>
                </button>
            </div>
            <div style="text-align: right; width: 100%;" class="mb-4 mt-1">
                <button @click="abrirModal(null, null, null)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">add</span> 
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Novo grupo</label>
                </button>
            </div>

            <div class="callout col-xl-12 col-lg-12 col-md-12 mb-4">
                    <div class="card" style="border-left-color: green;">
                        <div class="card-header" data-toggle="collapse" href="#collapse2" style="color: green;">
                            <strong>Grupos cadastrados</strong>
                        </div>
                        <div id="collapse2" class="collapse show">
                            <div class="card-body">
                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Descrição</th>
                                                <th scope="col" style="background-color: lightgrey;">Membros</th>
                                                <th scope="col" style="background-color: lightgrey;">Total membros</th>
                                                <th scope="col" style="background-color: lightgrey;">Editar grupo</th>
                                                <th scope="col" style="background-color: lightgrey;">Excluir</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="grupo in grupos">
                                                <td style="text-align: right; vertical-align: middle;">{{ grupo.id }}</td>
                                                <td style="text-align: left; vertical-align: middle;">{{ grupo.descricao }}</td>
                                                <td style="text-align: left; vertical-align: middle;">
                                                    <ul style="list-style-type: none; padding-left: 0;">
                                                        <li v-for="usuario in grupo.users" :key="usuario.id">{{ usuario.name }}</li>
                                                    </ul>
                                                </td>
                                                <td style="text-align: right; vertical-align: middle;">{{ grupo.users.length }}</td>
                                                <td style="text-align: center; vertical-align: middle;">
                                                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="abrirModal(grupo.id, grupo.descricao, grupo.users)">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">edit</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Editar</label>
                                                    </button>
                                                </td>
                                                <td style="text-align: center; vertical-align: middle;">
                                                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="deletarGrupo(grupo.id)">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>{{ grupos.length }} grupos(s) encontrado(s).</p>
                            </div>
                        </div>
                    </div>
                </div>

    </div>

                <!-- Modal -->
                <div class="modal fade" id="groupModal" tabindex="-1" role="dialog" aria-labelledby="groupModalLabel" aria-hidden="true"  v-show="exibirModal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="groupModalLabel">{{ modalTitle }}</h5>
                                <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="fecharModal">
                                    <span aria-hidden="true">&times;</span>
                                </button> -->
                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="salvarGrupo">
                                    <div class="form-group">
                                        <label for="descricaoGrupo">Descrição do Grupo</label>
                                        <input type="text" class="form-control" id="descricaoGrupo" v-model="grupo.descricao">
                                    </div>
                                    <div class="form-group pos-sugestoes">
                                        <label for="membroGrupo">Adicionar Membro </label>
                                        <span style="font-size: x-small;"> (Ou digite o nome da turma caso queira criar um grupo com a turma inteira).</span>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="membroGrupo"
                                            v-model="membro"
                                            @input="buscarMembros"
                                        >
                                        <span style="font-size: x-small;">Digite e selecione os membros deste grupo.</span>

                                        <div class="lista-sugestoes" v-if="sugestoesUsuarios.length || sugestoesTurmas.length">
                                            <div v-for="usuario in sugestoesUsuarios" :key="usuario.id" @click="adicionarMembro(usuario)">
                                                {{ usuario.name }} - {{ usuario.email }}
                                            </div>

                                            <div v-for="turma in sugestoesTurmas" :key="'turma-' + turma.id" @click="adicionarTurma(turma)">
                                                <strong>Turma:</strong> {{ turma.descricao }}
                                                <span v-if="turma.users"> ({{ turma.users.length }} membro(s))</span>
                                                    <!-- Prévia discreta dos membros -->
                                                <small
                                                    v-if="turma.users && turma.users.length"
                                                    class="text-muted d-block"
                                                    style="font-size: 0.7rem; margin-left: 8px;"
                                                >
                                                    {{ previewMembrosTurma(turma) }}
                                                </small>
                                            </div>
                                        </div>


                                    </div>

                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Membro</th>
                                                <th scope="col" style="background-color: lightgrey;">Excluir</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="membro in grupo.membros">
                                                <td style="text-align: right; vertical-align: middle;">{{ membro.id }}</td>
                                                <td style="text-align: left; vertical-align: middle;">{{ membro.name }}</td>
                                                
                                                <td style="text-align: center; vertical-align: middle;">
                                                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerMembro(membro.id)">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>{{ grupo.membros.length }} membro(s) encontrado(s).</p>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="fecharModal">Fechar</button> -->
                                <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="salvarGrupo">
                                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">done</span> 
                                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Salvar grupo</label>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


  </template>
  
<script>
  import axios from 'axios';
  import { Modal } from 'bootstrap';
  export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            pesquisar_por: '',
            campo_pesquisar: '',
            grupos: [],

            //Variaveis para o modal
            exibirModal: false,
            grupo: {
                descricao: '',
                membros: []
            },
            membro: '',
            sugestoesUsuarios: [],
            modalTitle: 'Novo Grupo',

            sugestoesTurmas: [], 

        };
        
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    methods: {
        previewMembrosTurma(turma) {
            if (!turma.users || !turma.users.length) {
                return '';
            }

            const nomes = turma.users.map(u => u.name);
            const limite = 3; // mostra só os 3 primeiros

            if (nomes.length <= limite) {
                return nomes.join(', ');
            }

            return nomes.slice(0, limite).join(', ') + '...';
        },
        CarregarGrupos(filtro = '', opcaoFiltro = 'descricao'){

            axios.get(this.BASE_URL + 'buscar_grupos', {
                    params: {
                        filtro: filtro,
                        opcaoFiltro: opcaoFiltro
                    }
                })
                .then(response => {
                    if (response.status === 200) {
                        this.grupos = response.data;
                    } else {
                        alert('Erro ao deletar registro.');
                    }
                })
                .catch(error => {
                    alert('Erro ao buscar registros: ' + error);
                    console.error(error);
                });
        },

        abrirModal(idDoGrupo = null, descricao_grupo = null, usuarios_grupo = null) {
            if (idDoGrupo) {
                this.grupo = { descricao: descricao_grupo, membros: usuarios_grupo, id: idDoGrupo};
                
            } else {
                // Configuração para um novo grupo
                this.grupo = { descricao: '', membros: [] };
                this.modalTitle = 'Novo Grupo';
                this.exibirModal = true;
            }

            console.log(this.grupo);

            this.$nextTick(() => {
                new Modal(document.getElementById('groupModal')).show();
            });
        },
        fecharModal() {
            new Modal(document.getElementById('groupModal')).hide();
        },
        buscarMembros() {
            if (this.membro.length > 2) {
                axios.get(this.BASE_URL + 'usuarios/buscar', { params: { query: this.membro } })
                    .then(response => {
                        this.sugestoesUsuarios = response.data;
                    })
                    .catch(error => {
                        alert('Erro na busca:', error);
                        console.error('Erro na busca:', error);
                    });


                axios.get(this.BASE_URL + 'turmas/buscar_turmas_users', { params: { query: this.membro } })
                    .then(respTurmas => {
                        this.sugestoesTurmas = respTurmas.data;
                    })
                    .catch(error => {
                        alert('Erro na busca de turmas:', error);
                        console.error('Erro na busca turmas:', error);
                    });


            }
        },
        adicionarMembro(usuario) {
            const jaEstaNoGrupo = this.grupo.membros.some(membro => membro.id === usuario.id);

            if (!jaEstaNoGrupo) {
                this.grupo.membros.push(usuario);
            } else {
                alert("Este usuário já foi adicionado ao grupo.");
            }

            this.membro = '';
            this.sugestoesUsuarios = [];
            this.sugestoesTurmas = [];
            this.enviarGrupo();
        },
        adicionarTurma(turma) {
            if (!turma.users || !turma.users.length) {
                alert('Esta turma não possui usuários vinculados.');
                return;
            }

            turma.users.forEach(usuario => {
                const jaEstaNoGrupo = this.grupo.membros.some(m => m.id === usuario.id);

                if (!jaEstaNoGrupo) {
                    this.grupo.membros.push(usuario);
                }
            });

            this.membro = '';
            this.sugestoesUsuarios = [];
            this.sugestoesTurmas = [];

            this.enviarGrupo();
        },        
        removerMembro(idMembro) {
            this.grupo.membros = this.grupo.membros.filter(membro => membro.id !== idMembro);
            this.enviarGrupo();
        },
        enviarGrupo(){
            axios.post(this.BASE_URL + 'grupos/salvar', this.grupo)
            .then(response => {
                const retorno = response.data;
                this.grupo = { descricao: retorno.descricao, membros: retorno.users, id: retorno.id };
            })
            .catch(error => {
                console.error("Erro ao salvar o grupo:", error);
            });
        },
        salvarGrupo(){
            this.enviarGrupo();
            alert("Grupo salvo com sucesso!");
            window.location.reload();
        },
        deletarGrupo(id) {
            if(confirm("Tem certeza que deseja deletar este grupo?")) {
                axios.post(this.BASE_URL + 'grupos/remover/' + id)
                    .then(response => {
                        alert("Grupo deletado com sucesso!");
                        this.CarregarGrupos();
                    })
                    .catch(error => {
                        console.error("Erro ao deletar o grupo:", error);
                    });
            }
        }

    },
    mounted() {
        this.CarregarGrupos();
    },
    
};
</script>

<style scoped>
/* wrapper do input precisa ser relative pra ancorar o dropdown */
.pos-sugestoes {
    position: relative;
}

/* container da lista vira um dropdown suspenso */
.lista-sugestoes {
    position: absolute;
    top: 100%;          /* logo abaixo do input */
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 0 0 4px 4px;
    max-height: 200px;  /* pra não ficar gigante */
    overflow-y: auto;
    z-index: 1000000;   /* acima do conteúdo do modal */
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

/* itens da lista (mantendo o que você já tinha) */
.lista-sugestoes div {
    cursor: pointer;
    padding: 5px 8px;
    border-bottom: 1px solid #eee;
}

.lista-sugestoes div:last-child {
    border-bottom: none;
}

.lista-sugestoes div:hover {
    background-color: #f0f0f0;
}
</style>
